import './RecordNameSection.scss';
import { ActiveIndicator } from '@ui/icons';
import { ifClickHandler } from '@lib/events';
import { SonarRecordParent } from '.';
import { SonarText } from '../text';
import { VersionNumber } from '@ui/VersionNumber';
import React, { useMemo } from 'react';
export const SonarRecordNameSection = ({ isActive, name, onClickParent, parentName, removeBold, showArrow, versionNumber }) => {
    const displayName = typeof name === 'string' ?
        React.createElement(SonarText, { weight: removeBold ? undefined : 'semibold' }, name) :
        name;
    const handleOnClickParent = useMemo(() => ifClickHandler(onClickParent), [onClickParent]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SonarRecordParent, { displayName: parentName, onClick: handleOnClickParent, showArrow: showArrow }),
        displayName,
        React.createElement(VersionNumber, { number: versionNumber }),
        React.createElement(ActiveIndicator, { isActive: isActive })));
};
